// Mutations will later be refactored into modules
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import createMutationsSharer from 'vuex-shared-mutations'
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import state from './state'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions: actions,
  getters: getters,
  state: state,
  mutations: mutations,
  plugins: [createPersistedState(), createMutationsSharer({ predicate: ['removeCurrentReportEntry', 'setCurrentReport', 'setCurrentReportComment', 'setCurrentReportOperatorId', 'setCurrentReportName', 'clearCurrentReport', 'setCurrentReportDateTime', 'setSelectedFlataRows', 'setSelectedFlata'] })],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js